import { render, staticRenderFns } from "./ZPaymentItem.vue?vue&type=template&id=39794c4b&scoped=true&"
import script from "./ZPaymentItem.vue?vue&type=script&lang=js&"
export * from "./ZPaymentItem.vue?vue&type=script&lang=js&"
import style0 from "./ZPaymentItem.vue?vue&type=style&index=0&id=39794c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39794c4b",
  null
  
)

export default component.exports